import '@usacow/ds/tokens.css';
import './app.css';
import './screens.css';
import './screens-app.css';
import './screens-guided.css';
import './screens-progress.css';
import './screens-contest.css';
import './screens-coach.css';
import './screens-admin.css';
import './screens-showcase.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { AuthProvider } from './lib/auth';
import { ErrorBoundary } from './ErrorBoundary';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
);
